import { ActionTypes } from "../actions/waitList";
import { ActionTypes as UserActionTypes } from "../actions/user";

export const initialState = Object.freeze({
  isLoading: false,
  applications: [],
});

export default (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case ActionTypes.APPLICANT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        applications: [].concat(state.applications, { eventId: payload, createdAt: Date.now() }),
      };
    }

    case ActionTypes.APPLICATIONS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        applications: payload,
      };
    }

    case UserActionTypes.LOGOUT_SUCCESS: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
